import e, { useEffect as r, createRef as n } from "react";
import a from "../../../../../services/Url.js";
import { s as t } from "../../../../../style-inject.es-1f59c1d0.js";
import "../../../../../_rollupPluginBabelHelpers-d2f9cf82.js";
t(".marker .pin {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  user-select: none;\n  cursor: pointer;\n  transform: translate(-50%, -100%); }\n  .marker .pin:hover {\n    z-index: 1; }\n\n.marker .balloonWrapper {\n  transition: opacity 0.3s;\n  padding-right: 0px;\n  padding-bottom: 0px;\n  max-width: 332px;\n  max-height: 605px;\n  min-width: 150px;\n  opacity: 0;\n  position: absolute;\n  box-sizing: border-box;\n  overflow: hidden;\n  top: 0;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  z-index: 1; }\n  .marker .balloonWrapper .balloon {\n    background-color: var(--background-color);\n    box-shadow: var(--boxshadow-reg);\n    border-radius: 8px;\n    padding: var(--gutter-m); }\n    .marker .balloonWrapper .balloon a {\n      color: inherit; }\n  .marker .balloonWrapper .arrow-down {\n    width: 0;\n    height: 0;\n    border-left: var(--gutter-m) solid transparent;\n    border-right: var(--gutter-m) solid transparent;\n    border-top: var(--gutter-m) solid var(--background-color); }\n");
var l = function (r) {
    var n = r.href,
      a = r.children;
    return n ? e.createElement("a", {
      href: n
    }, a) : e.createElement("span", null, a);
  },
  o = function (t) {
    var o,
      s = n(),
      i = n(),
      c = (o = t.merchant && t.merchant.localpageUrl) ? /^https?:\/\//i.test(o) ? a.modifyHTTP(o) : o : "";
    return r(function () {
      if (t.displayBalloon) {
        var e = s.current.offsetHeight;
        if (i.current) {
          var r = "translate(-50%, calc(-100% - ".concat(e + 5 + "px", "))");
          i.current.style.transform = r, i.current.style.opacity = 1;
        }
      }
    }, [t.displayBalloon]), e.createElement("div", {
      className: "marker"
    }, t.merchant && t.displayBalloon && e.createElement("div", {
      className: "balloonWrapper",
      ref: i
    }, e.createElement("div", {
      className: "balloon",
      style: t.config.balloon.style
    }, e.createElement(l, {
      href: c
    }, e.createElement("b", null, t.merchant.name), e.createElement("br", null), e.createElement("span", null, t.merchant.address.number, " ", t.merchant.address.street), e.createElement("br", null), t.merchant.address.street2 && e.createElement("span", null, t.merchant.address.street2), e.createElement("span", null, t.merchant.address.zip, " - ", t.merchant.address.city), e.createElement("br", null))), e.createElement("div", {
      className: "arrow-down"
    })), e.createElement("img", {
      loading: "lazy",
      className: "pin",
      src: t.icon,
      alt: "google marker",
      ref: s
    }));
  };
export { o as default };